import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { ImageFigure } from '../case-study/ImageFigure';
import { botkeeperAttentionStudy, botkeeperAttentionVariants, botkeeperImages } from '../../data/botkeeper';
const CTA_BENCHMARK = 2.4;

/** Summary of the Attention Insight report on four Settings layouts. */
export function AttentionStudy() {
  return <div className="mt-14 border-t border-line pt-10" data-id="element-37" data-mp="ph24cwl6yoz9">
      <div className="grid gap-6 md:grid-cols-[1fr_1.2fr] md:gap-12" data-id="element-38" data-mp="pf7j1h60cuun">
        <div data-id="element-39" data-mp="u8sgn83ovmtb">
          <h3 className="text-lg font-semibold text-fg" data-id="element-40" data-mp="u9bry5yu3cyd">The attention study behind the gear</h3>
          <p className="mt-3 text-sm leading-relaxed text-fg-muted" data-id="element-41" data-mp="gigqheqnzy4t">
            Before testing with people, I ran four desktop layouts of the Settings page through Attention Insight, an AI
            model trained on 5.5M+ eye-tracking fixations (about 90% accurate for web designs in the first 3–5 seconds).
          </p>
          <p className="mt-3 text-sm leading-relaxed text-fg-muted" data-id="element-42" data-mp="bjdm7wiidvxw">
            All four scored within the optimal clarity range, and in every one attention landed on the partners table’s
            column headers — the data, not the navigation. The settings controls themselves stayed below the 2.4% average
            attention, which is why the gear got a tooltip.
          </p>
          <a href={botkeeperAttentionStudy} target="_blank" rel="noreferrer" className="group mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-ink underline decoration-line underline-offset-4 transition-colors duration-150 hover:decoration-ink" data-id="element-43" data-mp="24icxikorks0m">
            View the full attention report (PDF)
            <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-44" data-mp="1lt6e0vg5bwdr" />
          </a>
        </div>

        <Reveal data-id="element-45" data-mp="t62dp3s0068b">
          <div className="overflow-x-auto rounded-2xl border border-line" data-id="element-46" data-mp="t4ix1c2fjt60">
            <table className="w-full min-w-[420px] text-left text-sm" data-id="element-47" data-mp="2t8bq0y2eokuf">
              <caption className="sr-only" data-id="element-48" data-mp="2y6n099wm4xd6">Attention Insight results for four Settings layouts</caption>
              <thead className="bg-surface text-xs text-fg-faint" data-id="element-49" data-mp="32xd7ksolnaai">
                <tr data-id="element-50" data-mp="32y4yhq794jug">
                  <th scope="col" className="px-4 py-3 font-medium" data-id="element-51" data-mp="37wgb28oxl8gd">Layout</th>
                  <th scope="col" className="px-4 py-3 font-medium" data-id="element-52" data-mp="37yiyqm2m2phx">Clarity</th>
                  <th scope="col" className="px-4 py-3 font-medium" data-id="element-53" data-mp="2aa8v62n6ftop">Attention on controls</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-line" data-id="element-54" data-mp="2f9lqzcw10b3f">
                {botkeeperAttentionVariants.map(v => <tr key={v.name} data-id="element-55" data-mp="2o878r5tobm35">
                    <th scope="row" className="px-4 py-3.5 align-top font-normal" data-id="element-56" data-mp="2o98jtaaow8kv">
                      <span className="block font-medium text-fg" data-id="element-57" data-mp="3vmsep7d58j15">{v.name}</span>
                      <span className="mt-0.5 block text-xs text-fg-faint" data-id="element-58" data-mp="3hydxhmvrlz2">{v.placement}</span>
                    </th>
                    <td className="px-4 py-3.5 align-top" data-id="element-59" data-mp="1o0inv018vn7i">
                      <span className="font-medium tabular-nums text-fg" data-id="element-60" data-mp="1o23j6rvdva6f">{v.clarity}%</span>
                      <span className="ml-1.5 text-xs text-ink" data-id="element-61" data-mp="1k11evwmm07xl">optimal</span>
                    </td>
                    <td className="px-4 py-3.5 align-top" data-id="element-62" data-mp="1f5m4jent8u5x">
                      <span className="flex flex-wrap gap-1.5" data-id="element-63" data-mp="1a82qaer44hdz">
                        {v.cta.map((c, i) => {
                      const above = parseFloat(c) >= CTA_BENCHMARK;
                      return <span key={i} className={`rounded-full px-2 py-0.5 text-xs font-medium tabular-nums ${above ? 'bg-ink-soft text-ink' : 'bg-coral-soft text-rust'}`} data-id="element-64" data-mp="10csn3noza3ym" data-mpi={i}>
                              {c}
                            </span>;
                    })}
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <p className="mt-2 text-xs text-fg-faint" data-id="element-65" data-mp="1na3yf6kd0qgd">Coral: below the 2.4% average attention for a call to action.</p>
        </Reveal>
      </div>

      <ImageFigure className="mt-10" {...botkeeperImages.heatmap} caption="Attention heat-map: the hotspots sit on the table’s column headers, not on the navigation." data-id="element-66" data-mp="1eb0c7tpwbuxn" />
    </div>;
}